/* eslint-disable @next/next/no-img-element */
import { useState } from 'react'
import UserAvatarExternal from 'react-user-avatar'
import { cn } from 'common/utils'
import { useHasMounted } from 'common/hooks'

const blankSrc = '/missing.gif'

// TODO: this still results in console warnings about mismatched HTML on server vs client (but at least it succeeds in hiding the broken images)
//    Warning: Extra attributes from the server: onerror
//
// Other ideas: https://makaroni4.com/2019/01/06/cross-browser-solution-for-styling-broken-images-with-js/
const ClearbitLogoFor = ({ domainKey, className, size = 128 }) => {
  const [error, setError] = useState(false)
  const src = `https://logo.clearbit.com/${domainKey}?size=${size}`
  const cls = error ? 'hidden' : cn(className, 'max-w-full h-auto')
  const hasMounted = useHasMounted()

  if (!hasMounted) {
    // Server-side rendering might not be hydrated in time for onError event to be attached before img fails to load.
    // Work around by setting onerror directly in HTML
    const imgHtml = `<img src="${src}" alt="Logo for ${domainKey}" class="${cls}" width="${size}" onerror="this.onerror=null;console.log('Image failed to load:', this.src);'${blankSrc}'"/>`
    return (
      <div
        key="extImg"
        className="externalImage inline"
        dangerouslySetInnerHTML={{ __html: imgHtml }}
      />
    )
  }

  if (error) return <UserAvatarExternal size={size} name={domainKey} />

  return (
    <div key="extImg" className="externalImage inline">
      <img
        src={src}
        alt={`Logo for ${domainKey}`}
        className={cls}
        width={size} // TODO: size is the largest dimension, it might not be width
        // onError={`this.src = "${blankSrc}"`}
        onError={(e) => {
          console.warn('Img failed to load: ', e)
          setError(e)
        }}
      />
    </div>
  )
}

export default ClearbitLogoFor
